<template>
    <div>
        <h2 class="text-center mb-3">บันทึกรับชำระหนี้</h2>

        <div class="row">
            <div class="col col-6">
                <label>ช่องทางการชำระ</label>
            </div>
            <div class="col col-6">
                <b-form-select
                    v-model="form.transaction_type_id"
                    :options="transactionTypes"
                    @input="changeTransactionType"/>
            </div>
        </div>

        <hr>

        <template v-for="(transaction, index) in form.transactions">
            <template v-if="form.transaction_type_id == 1 || form.transaction_type_id == 2">
                <!-- Ref No -->
                <div class="row form-group">

                    <div class="col col-6">
                        <label :for="`ref_no${index}`">
                            <template v-if="form.transaction_type_id == 1">
                                เลขที่เช็ค
                            </template>
                            <template v-if="form.transaction_type_id == 2">
                                รหัสบัญชี
                            </template>
                        </label>
                    </div>
                    <div class="col col-6">
                        <input
                            :id="`ref_no${index}`"
                            class="form-control"
                            type="text"
                            v-model="transaction.ref_no">
                    </div>
                </div>
            </template>

            <!-- Date -->
            <div class="row form-group">
                <div class="col col-6">
                    <label :for="`date${index}`">
                        <template v-if="form.transaction_type_id == 1">
                            วันที่ขึ้นเงิน
                        </template>
                        <template v-if="form.transaction_type_id == 2">
                            วันที่โอน
                        </template>
                        <template v-if="form.transaction_type_id == 3">
                            วันที่
                        </template>
                    </label>
                </div>
                <div class="col col-6">
                    <!-- Search By Date Range -->
                    <date-picker
                        :id="`date${index}`"
                        v-model="transaction.date"
                        class="w-100"
                        :lang="lang"
                        :format="changeFormat"
                        placeholder="วันที่ขึ้นเงิน">
                    </date-picker>
                </div>
            </div>

            <!-- Amount -->
            <div class="row form-group">
                <div class="col col-6">
                    <label :for="`amount${index}`">
                        ยอดเงิน
                    </label>
                </div>
                <div class="col col-6">
                    <input
                        required
                        :id="`amount${index}`"
                        class="form-control"
                        type="number"
                        v-model="transaction.amount">
                </div>
            </div>

            <hr>
        </template>

        <template v-if="form.transaction_type_id == 1 || form.transaction_type_id == 2">
            <div class="form-group">
                <button @click="addPaymentTransaction"
                        type="button"
                        class="btn btn-primary">
                    <icon name="plus"></icon>
                    เพิ่มรายการ
                </button>

                <hr>
            </div>
        </template>


        <div class="form-group row">
            <div class="col col-sm-6">
                <label>
                    ยอดเงินที่ค้างชำระ
                </label>
                <h2 class="form-control-plaintext">{{ paymentLimit | currency }}</h2>
            </div>

            <div class="col col-sm-6 text-right">
                <label>
                    รวมยอดเงินที่บันทึก
                </label>
                <h2 class="form-control-plaintext"
                    :class="{ 'text-danger': !canSubmit }">
                    <template v-if="totalPrice">
                        {{ totalPrice | currency }}
                    </template>
                    <template v-else>0</template>
                </h2>
            </div>
        </div>

        <div class="col text-center">
            <button @click="submitPayment"
                    type="button"
                    class="btn btn-success"
                    :disabled="!canSubmit">
                <icon name="save" style="width: 25px"></icon>
                บันทึก
            </button>
            &nbsp
            <button @click="cancelSubmit"
                    type="button"
                    class="btn btn-outline-secondary">
                <icon name="times" style="width: 25px"></icon>
                ยกเลิก
            </button>
        </div>
        <!--<pre class="alert-danger">{{form}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex"
import DatePicker from 'vue2-datepicker'
import moment from "moment";

export default {
    name: "payment-modal",
    components: {
        DatePicker
    },
    data() {
        return {
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    computed: {
        ...mapState({
            form: state => {
                return state.Payment.paymentForm
            },
            paymentLimit: state => {
                return state.Payment.paymentLimit
            },
            transactionTypes: state => {
                return state.TransactionType.transactionTypes.map(type => ({
                    value: type.id,
                    text: type.name
                }))
            },
        }),
        totalPrice() {
            return this.form.transactions.reduce((carry, transaction) => {
                return parseFloat(transaction.amount) + carry
            }, 0)
        },
        canSubmit() {
            return this.totalPrice === this.paymentLimit
        }
    },
    created() {
        this.$store.dispatch("TransactionType/setTransactionTypes");
    },
    methods: {
        submitPayment() {
            this.form.transactions.forEach(transaction => {
                if (!transaction.date) {
                    const currentDate = moment().format("YYYY-MM-DD");
                    transaction.date = currentDate;
                }
                if (!transaction.amount) {
                    transaction.amount = 0;
                }
            });
            this.$emit('submit', true);
        },
        cancelSubmit() {
            this.$emit('submit', false)
        },
        addPaymentTransaction() {
            this.$store.dispatch("Payment/addPaymentTransaction")
        },
        changeTransactionType(type) {
            //console.log(type)
            if (type == 3) {
                this.$store.dispatch("Payment/setTransactionsForCash")
            }
        }
    }
}
</script>

<style scoped>

</style>
